import { Link } from 'gatsby'
import styled from 'styled-components'

const LinkStyle = styled(Link)`
    font-weight: 700;
    color: inherit;
    text-decoration: none;
`

export default LinkStyle